<template>
  <div class="content">
    <search v-model="searchValue" placeholder="搜索科室/医生" @clearValue="clearValue" @keypress="keypress"></search>
    <treeSelect :items="items" @toRegistration="toRegistration" height="80vh"></treeSelect>
  </div>
</template>

<script>
  import search from '../common/Search'
  import treeSelect from '../common/TreeSelect'
  import {guidanceGetks} from '../../api/index'
    export default {
      data(){
        return{
          searchValue:'',
          items:[
            {
              科室名称:'其他',
              科室代码:'0',
              children:[
              ]
            },
            // {
            //   科室名称:'核酸检测预约',
            //   科室代码:'0',
            //   children:[
            //     {
            //       科室代码: "new",
            //       科室名称: "核酸检测预约"
            //     }
            //   ]
            // }
          ]
        }
      },
      components:{
        search,
        treeSelect
      },
      created() {
        //修改标题
        document.title = '预约挂号'
        this.guidanceGetks()
      },
      methods:{
        guidanceGetks(){
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          guidanceGetks().then(res=>{
            loading.close();
            this.items[0].children.push.apply(this.items[0].children,res.Data)
          })
        },
        //清空搜索框
        clearValue(){
          this.searchValue = ''
        },
        //确定搜索
        keypress(e){
          //判断点击键盘确定按钮
          if(e.key=="Enter"){
            console.log(e.target.value)
          }
        },
        //跳转到门诊部列表
        toRegistration(item){
          if(item.科室代码=='new'){
            window.location.href = 'http://2021quarantine.17xueba.cn/Index/detection.html'
          }else {
            this.$router.push({path:'/outpatient',query: {ksname: item.科室名称,ksId:item.科室代码}})
          }
        },
      }
    }
</script>

<style scoped>
  .content{
    background-color: #f0f0f0;
    width: 100%;
    height: 100vh;
    font-size: .28rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/registration.vue